import { Checkbox, Flex, Switch, Typography } from 'antd'
import { Controller, FieldErrors } from 'react-hook-form'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { colorTextGray1, success } from 'src/app/themes/primaryThemeDefault'
import './index.scss'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { useTranslation } from 'react-i18next'

interface IOption {
  id: number
  name?: string
  allowBankUsersToEditEmailNotifications?: boolean
  createdBy?: string | null
  createdOn?: string | null
  emailMessage?: string | null
  emailSubject?: string | null
  emailType?: string | null
  tenantId?: string | null
  updatedBy?: string | null
  updatedOn?: string | null
  userNotificationTypeAssignments?: string | null
}

interface IProps {
  control: any
  title: string
  name: string
  listSwitchers: Array<IOption>
  errors?: FieldErrors<any>
  getValues?: any
  setValue?: any
  isTurnOnFirst?: boolean
  data?: any
  resetField?: any
  trigger: any
  allOptionName: string
  defaultPermission: string
}

const Switchers = (props: IProps) => {
  const { t } = useTranslation()
  const {
    control,
    name,
    setValue,
    getValues,
    isTurnOnFirst,
    data,
    trigger,
    allOptionName,
    listSwitchers,
    defaultPermission,
  } = props

  const handleOnChangeSwitch = (e: any, id: number, field: any, setValue: any, getValues: any) => {
    field.onChange(e)
    const tmp = getValues(name) ?? []
    const SetTmp = new Set(tmp)
    if (SetTmp.has(id)) {
      SetTmp.delete(id)
    } else {
      SetTmp.add(id)
    }
    setValue(name, Array.from(SetTmp))

    if (Array.from(SetTmp)?.length === listSwitchers?.length) {
      setValue(allOptionName, true)
    } else {
      setValue(allOptionName, false)
    }
  }

  const handleCheckOnchange = (e: CheckboxChangeEvent, field: any) => {
    field.onChange(e)
    if (e.target.checked) {
      setValue(
        name,
        listSwitchers?.map((item) => item?.id),
      )
    } else {
      setValue(name, [defaultPermission])
    }
    trigger(name)
  }

  return (
    <Flex vertical style={{ marginBottom: 24 }}>
      <Flex justify='space-between' align='center'>
        <Typography.Paragraph style={{ marginBottom: 12 }} className='switcher-title'>
          {props.title}
        </Typography.Paragraph>

        <Controller
          name={allOptionName}
          control={control}
          render={({ field }) => (
            <Checkbox
              {...field}
              checked={field.value}
              style={{ marginBottom: 12 }}
              onChange={(e: CheckboxChangeEvent) => {
                handleCheckOnchange(e, field)
              }}
            >
              {t('UserRoles:selectAllPermissions')}
            </Checkbox>
          )}
        />
      </Flex>
      <Flex
        vertical
        style={{
          padding: '8px 0px',
          border: `1px solid ${colorTextGray1} `,
          borderRadius: '16px',
        }}
      >
        <Flex vertical gap={25} style={{ padding: '13px 24px 24px 24px', height: 250, overflowY: 'scroll' }}>
          {props.listSwitchers?.map((item, idx) => {
            return (
              <Flex gap={12} key={`${item?.id}`}>
                <Controller
                  name={name + `${item?.id}`}
                  control={control}
                  render={({ field }) => {
                    return (
                      <Switch
                        {...field}
                        style={data?.includes(item?.id) ? { background: success } : {}}
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        onChange={(e) => {
                          handleOnChangeSwitch(e, item?.id, field, setValue, getValues)
                        }}
                        disabled={isTurnOnFirst ? idx === 0 : false}
                        defaultValue={data?.includes(item?.id)}
                        checked={data?.includes(item?.id)}
                      />
                    )
                  }}
                />
                <Typography>{item?.name ?? item?.emailType}</Typography>
              </Flex>
            )
          })}
        </Flex>
      </Flex>
    </Flex>
  )
}

export default Switchers
